import { Templates } from "~/features/templates/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const TemplatesPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlTemplatesPage");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <Templates /> : <Construction />;
};
